import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { message } from 'antd'
import { cloneDeep } from 'lodash-es'
import classNames from 'classnames'
import { picProcess } from '../../../utils/image'
import request from '../../../utils/request'
import Button from '../../../baseComponent/button'
import Icon from '../../icon'
import Checkbox from '../../../baseComponent/checkbox'
import { MODES } from '../enum'
import './index.less'

const CROSS_BORDER_PRODUCT_MAX_SELECT_COUNT = 50
const CROSS_BORDER_PRODUCT_LIMIT_TIP = '至多选中50张图片'

const isCrossBorderPath = () => {
  const pathname = typeof window === 'undefined' ? '' : window.location?.pathname || ''
  return pathname.includes('/cross-border') || pathname.includes('/cross-boerder')
}

const getImageUrl = (image) => {
  if (!image) return null
  if (typeof image === 'string') return image
  return image.url || image.imageUrl || image.imgUrl || image.picUrl || image.mainUrl || image.colorImg || image.searchImg || image.ossMainImageUrl
}

const appendImages = (target, images) => {
  if (Array.isArray(images)) {
    images.forEach((image) => {
      const url = getImageUrl(image)
      if (url) target.push(url)
    })
    return
  }
  const url = getImageUrl(images)
  if (url) target.push(url)
}

const getProductImages = (currentViewBlog, skuImage, mainUrl, picUrl) => {
  const images = []
  appendImages(images, currentViewBlog?.imageObjectList)
  appendImages(images, currentViewBlog?.imgUrlList)
  appendImages(images, currentViewBlog?.picUrlList)
  appendImages(images, currentViewBlog?.picList)
  appendImages(images, currentViewBlog?.detailUrls?.split?.(','))
  appendImages(images, currentViewBlog?.skuImage)
  appendImages(images, skuImage)
  appendImages(images, currentViewBlog?.mainUrl)
  appendImages(images, mainUrl)
  appendImages(images, currentViewBlog?.picUrl)
  appendImages(images, picUrl)
  currentViewBlog?.skcInfoList?.forEach?.((skc) => {
    appendImages(images, skc?.picList)
    appendImages(images, skc?.colorImg)
    appendImages(images, skc?.searchImg)
    appendImages(images, skc?.picUrl)
  })
  return images.filter(Boolean)
}

const isCrossBorderProductCollect = (currentViewBlog) => {
  if (!isCrossBorderPath()) return false
  return !!(currentViewBlog?.productId || currentViewBlog?.productKey || (currentViewBlog?.itemId && currentViewBlog?.productName))
}

const getLimitedImages = (images, maxSelectCount) => (maxSelectCount ? images.slice(0, maxSelectCount) : images)

const showProductLimitTip = () => {
  message.info(CROSS_BORDER_PRODUCT_LIMIT_TIP)
}

const getNextSelectedImages = (selected, val, maxSelectCount) => {
  const selectedImages = selected || []
  const index = selectedImages.findIndex((i) => i === val)
  if (index !== -1) {
    return selectedImages.filter((i) => i !== val)
  }
  if (maxSelectCount && selectedImages.length >= maxSelectCount) {
    showProductLimitTip()
    return selected
  }
  return [...selectedImages, val]
}

const THUMBNAIL_SIZE = 56
const THUMBNAIL_GAP = 4
const VISIBLE_THUMBNAIL_COUNT = 4
const THUMBNAIL_STEP = THUMBNAIL_SIZE + THUMBNAIL_GAP
const TILE_IMG_SIZE = 72

export default forwardRef(
  (
    {
      onChange, colorId, blogId, platformId, skuImage, mainUrl, hasCurInstated, inspirationId,
      picUrl, sitePlatformId, currentViewBlog, skc, fixedViewSize, ...props
    },
    ref
  ) => {
    const [mode, setMode] = useState(1)
    const [data, setData] = useState([])
    const [values, setValues] = useState([])
    const isProductCollect = isCrossBorderProductCollect(currentViewBlog)
    const maxSelectCount = isProductCollect ? CROSS_BORDER_PRODUCT_MAX_SELECT_COUNT : undefined

    const _onChange = (val) => {
      setValues(val)
      onChange?.(val)
    }
    useEffect(() => {
      fetchData()
    }, [])

    const updateImageList = (images = []) => {
      const imageList = Array.isArray(images) ? images : [images]
      const nextData = imageList.filter(Boolean)
      const nextValues = getLimitedImages(nextData, maxSelectCount)
      onChange?.(nextValues)
      setValues(nextValues)
      setData(nextData)
    }

    const fetchData = async () => {
      if (blogId && platformId && !isNaN(platformId)) {
        const params = {
          blogId,
          platformId,
          sitePlatformId,
          colorId,
          skc,
        }
        if (hasCurInstated && inspirationId) {
          params.inspirationId = inspirationId
        }
        const result = await request
          .get('/zhikuan/inspiration/blog/get-blog-images', {
            params,
            ignoreError: true,
          })
          .catch((error) => {
            message.error(error.errorDesc)
          })
        setTimeout(() => {
          // 其他项目的message无法关闭 为了主动关闭
          message.destroy()
        }, 8000)
        if (result) {
          updateImageList(result)
        } else {
          updateImageList([])
        }
      } else {
        const productImages = isProductCollect ? getProductImages(currentViewBlog, skuImage, mainUrl, picUrl) : []
        const imageList = productImages.length ? productImages : [skuImage || mainUrl || picUrl].filter(Boolean)
        if (imageList.length) {
          updateImageList(imageList)
        }
      }
    }

    useImperativeHandle(ref, () => {
      return {
        images: values,
      }
    })

    const renderDom = () => {
      if (data.length <= 1 || props.mode === MODES.PURCHASE) {
        const coverImage = data[0] || skuImage || mainUrl || picUrl
        return (
          <div className={classNames('mn-cover-wrap', { 'fixed-view-size': fixedViewSize })}>
            <div className="mn-cover" style={{ background: `url(${coverImage}) center/cover no-repeat` }}>
              {props.imageNum ? <div className="mn-collect-modal-big-img-wrap-cover-img-num">{props.imageNum} 个款式</div> : null}
            </div>
          </div>
        )
      }
      if (mode === 1) {
        return (
          <BigImg
            mode={mode}
            imageNum={props.imageNum}
            data={data}
            value={values}
            onChange={_onChange}
            onMode={() => setMode(2)}
            maxSelectCount={maxSelectCount}
            fixedViewSize={fixedViewSize}
          />
        )
      }
      return (
        <TileImg
          mode={mode}
          value={values}
          onMode={() => setMode(1)}
          onChange={_onChange}
          data={data}
          maxSelectCount={maxSelectCount}
          fixedViewSize={fixedViewSize}
        />
      )
    }
    return <div className="mn-collect-modal-img-wrap">{renderDom()}</div>
  }
)

const BigImg = ({ mode, onMode, value, onChange, data = [], maxSelectCount, fixedViewSize }) => {
  const [selected, setSelected] = useState([])
  const [imgIndex, setImgIndex] = useState(0)
  const [thumbTop, setThumbTop] = useState(0)
  const onSelect = (val) => {
    setImgIndex(val)
  }

  const _onChange = (item, val) => {
    const nextSelected = getNextSelectedImages(selected, val, maxSelectCount)
    if (nextSelected === selected) return
    setSelected(nextSelected)
    onChange?.(nextSelected)
  }

  useEffect(() => {
    setSelected(cloneDeep(value))
  }, [value])

  const canPrev = thumbTop <= -THUMBNAIL_STEP
  const canNext = data.length > VISIBLE_THUMBNAIL_COUNT && thumbTop > -(data.length - VISIBLE_THUMBNAIL_COUNT) * THUMBNAIL_STEP

  useEffect(() => {
    setThumbTop(0)
    setImgIndex(0)
  }, [data])

  return (
    <div className={classNames('mn-collect-modal-mode-big-img', { 'fixed-view-size': fixedViewSize })}>
      <div className="mn-collect-modal-mode-big-img-body">
        <div className="mn-collect-modal-big-img-wrap">
          {data.length ? <div className="mn-collect-modal-big-img-wrap-cover-img-num">{data.length}张图片</div> : null}
          <img referrerPolicy="no-referrer" className="mn-collect-modal-big-img" src={picProcess(data[imgIndex])} />
        </div>
        <div className="mn-collect-modal-mode-big-img-switch">
          <div
            className={classNames('mn-collect-modal-mode-big-img-switch-btn', { disabled: !canPrev })}
            onClick={() => {
              if (canPrev) {
                setThumbTop((pre) => pre + THUMBNAIL_STEP)
              }
            }}
          >
            <Icon type="m-Vxing_shang" />
          </div>
          <div className="mn-collect-modal-mode-big-img-switch-middle-wrap">
            <div
              className="mn-collect-modal-mode-big-img-switch-middle"
              style={{ height: data.length * THUMBNAIL_STEP, transform: `translateY(${thumbTop}px)` }}
            >
              {data.map((item, index) => (
                <ImgCheckbox
                  key={item}
                  item={item}
                  index={index}
                  value={selected}
                  imgIndex={imgIndex}
                  onChange={_onChange}
                  onSelect={onSelect}
                  width={THUMBNAIL_SIZE}
                  height={THUMBNAIL_SIZE}
                  maxSelectCount={maxSelectCount}
                />
              ))}
            </div>
          </div>
          <div
            className={classNames('mn-collect-modal-mode-big-img-switch-btn', { disabled: !canNext })}
            onClick={() => {
              if (canNext) {
                setThumbTop((pre) => pre - THUMBNAIL_STEP)
              }
            }}
          >
            <Icon type="m-Vxing_xia" />
          </div>
        </div>
      </div>
      <ImgFooter
        mode={mode}
        onMode={onMode}
        value={selected}
        setValue={setSelected}
        onChange={onChange}
        data={data}
        maxSelectCount={maxSelectCount}
      />
    </div>
  )
}

const TileImg = ({ mode, onMode, value, onChange, data = [], maxSelectCount, fixedViewSize }) => {
  const [selected, setSelected] = useState([])

  const _onChange = (item, val) => {
    const nextSelected = getNextSelectedImages(selected, val, maxSelectCount)
    if (nextSelected === selected) return
    setSelected(nextSelected)
    onChange?.(nextSelected)
  }

  useEffect(() => {
    setSelected(cloneDeep(value))
  }, [value])

  return (
    <div className={classNames('mn-collect-modal-mode-tile-img', { 'fixed-view-size': fixedViewSize })}>
      <div className="mn-collect-modal-mode-tile-img-wrap">
        <div className="mn-collect-modal-mode-tile-img-list">
          {data.map((item, index) => (
            <ImgCheckbox
              key={item}
              item={item}
              value={selected}
              index={index}
              onChange={_onChange}
              width={fixedViewSize ? TILE_IMG_SIZE : 100}
              height={fixedViewSize ? TILE_IMG_SIZE : 100}
              imgSelectedMode
              maxSelectCount={maxSelectCount}
            />
          ))}
        </div>
      </div>
      <ImgFooter
        mode={mode}
        onMode={onMode}
        value={selected}
        setValue={setSelected}
        onChange={onChange}
        data={data}
        maxSelectCount={maxSelectCount}
      />
    </div>
  )
}

// imgSelected 支持图片选中
const ImgCheckbox = ({ item, value, imgIndex, index, onChange, onSelect, width, height, imgSelectedMode, maxSelectCount }) => {
  const checked = value.some((i) => i === item)
  const disabled = !!(maxSelectCount && !checked && value.length >= maxSelectCount)
  const onToggle = () => {
    if (disabled) {
      showProductLimitTip()
      return
    }
    onChange?.(item, item)
  }
  return (
    <div
      className={classNames('mn-collect-modal-img-checkbox', { active: imgIndex === index, disabled })}
      onClick={(e) => {
        e.stopPropagation()
        if (imgSelectedMode) {
          onToggle()
        }
        onSelect?.(index, item)
      }}
      style={{
        width,
        height,
      }}
    >
      <Checkbox
        checked={checked}
        disabled={disabled}
        className="mn-collect-modal-img-checkbox-checkbox"
        onClick={(e) => {
          e.stopPropagation()
          if (disabled) {
            showProductLimitTip()
          }
        }}
        onChange={() => {
          onToggle()
        }}
      />
      <img referrerPolicy="no-referrer" src={picProcess(item)} className="mn-collect-modal-img-checkbox-img" />
    </div>
  )
}

const ImgFooter = ({ mode, onMode, value, setValue, onChange, data, maxSelectCount }) => {
  const updateSelected = (nextValue) => {
    setValue(nextValue)
    onChange?.(nextValue)
  }
  const onAll = () => {
    updateSelected(getLimitedImages([...data], maxSelectCount))
  }
  const onInvert = () => {
    const _data = getLimitedImages(data.filter((i) => !value.includes(i)), maxSelectCount)
    updateSelected(_data)
  }
  return (
    <div className="mn-collect-modal-mode-big-img-footer">
      <div className="df-center cursor-pointer" onClick={() => onMode()}>
        <Icon type={`${mode === 1 ? 'm-duotumoshi' : 'm-kapianmoshi'}`} style={{ fontSize: '16px' }} />
        <div style={{ color: 'var(--m-text-1)', marginLeft: '4px' }}>{mode === 1 ? '切换平铺视图' : '切换大图视图'}</div>
      </div>
      <div className="df-center">
        <div style={{ fontSize: '12px' }}>
          <span style={{ color: 'var(--m-text-3)' }}>已选</span>{' '}
          <span style={{ color: 'var(--m-text-1)', marginLeft: '4px' }}>
            {value.length}/{data.length}
          </span>
        </div>
        <Button className="mn-collect-modal-mode-big-img-footer-btn" style={{ marginLeft: '16px' }} onClick={() => onInvert()}>
          反选
        </Button>
        <Button className="mn-collect-modal-mode-big-img-footer-btn" style={{ marginLeft: '8px' }} onClick={() => onAll()}>
          全选
        </Button>
      </div>
    </div>
  )
}
